import PlainPaging from 'app/common/ui-next/plain-paging'

import { useDishesData } from 'app/dataProviders/dishes/DishesData'

export const AddRawItemsPager = () => {
  const [{ dishes, total, limit }, , { currentPage, handlePage }] = useDishesData()

  return (
    <PlainPaging
      total={total}
      perPage={limit}
      currentPageIndex={currentPage - 1}
      currentPageSize={dishes.length}
      onPage={handlePage}
    />
  )
}
